// extracted by mini-css-extract-plugin
export default {"message":"VerifyEmail_message__XfMvy","groupTitle":"VerifyEmail_groupTitle__xE-fl"};